import React from 'react';

export const Home0 = () => {

  return <div className='.modifier'>
      <h1> Home page 0 </h1>
  </div>
}
